// @flow

import leftPad from 'left-pad'

const SECOND = 1000
const MINUTE = SECOND * 60
const HOUR = MINUTE * 60

export const getTimeSegments = (
  totalTime: number,
  factors: Array<number> = [HOUR, MINUTE, SECOND],
  padding: number = 2,
): Array<string> => {
  return factors.map(factor => {
    const result = Math.max(0, Math.floor(totalTime / factor))
    totalTime -= result * factor
    return leftPad(String(result), padding, 0)
  })
}

export const getTimeDisplay = (start, end) => {
  let time
  if (typeof end === 'undefined') {
    time = start
  } else {
    time = end - start
  }

  return getTimeSegments(time).join(':')
}



// WEBPACK FOOTER //
// ./src/lib/time.js